import './styles.css';
import {calculatePrice} from "../../helpers/constants";


export default function Cards({rangeValue, currency, measure}) {
    let {
        helicopterCO,
        droneCO,
        satellitePrice,
        satellitePriceEuro,
        helicopterTime,
        droneTime,
        satelliteTime,
        moreThan
    } = calculatePrice;

    //COMPARE VALUE CO2 EMISSION SATELLITE vs HELICOPTER and DRONE
    const saveCO2EmissionHelicopter = measure === "km"
        ? Math.ceil(helicopterCO * rangeValue)
        : Math.ceil(helicopterCO * (rangeValue / 0.6214));
    const saveCO2EmissionDrone = measure === "km"
        ? Math.ceil(droneCO * rangeValue)
        : Math.ceil(droneCO * (rangeValue / 0.6214));

    // COMPARE PRICE SATELLITE vs HELICOPTER and DRONE
    let helicopterPrice = satellitePrice / 100 * 440; // 22
    let dronePrice = satellitePrice / 100 * 220; // 11
    let helicopterPriceEuro = satellitePriceEuro / 100 * 440; // 13.2
    let dronePriceEuro = satellitePriceEuro / 100 * 220; // 6.6

    //DOLLAR PRICE toggle between thousands and millions
    const saveMoneyCompareWithHelicopter = (((helicopterPrice * rangeValue / 1000)) - ((satellitePrice * rangeValue / 1000))).toFixed(1) > moreThan
        ? ((Math.abs(helicopterPrice * rangeValue / 1.0e+6)) - (Math.abs(satellitePrice * rangeValue / 1.0e+6))).toFixed(1) + " million"
        : (((helicopterPrice * rangeValue / 1000)) - ((satellitePrice * rangeValue / 1000))).toFixed(1) + " thousands";

    const saveMoneyCompareWithDrone = (((dronePrice * rangeValue) / 1000) - ((satellitePrice * rangeValue) / 1000)).toFixed(1);

    //EURO PRICE
    const saveMoneyCompareWithHelicopterEuro = (((helicopterPriceEuro * rangeValue / 1000)) - ((satellitePriceEuro * rangeValue / 1000))).toFixed(1) > moreThan
        ? ((Math.abs(helicopterPriceEuro * rangeValue / 1.0e+6)) - (Math.abs(satellitePriceEuro * rangeValue / 1.0e+6))).toFixed(1) + " million"
        : (((helicopterPriceEuro * rangeValue / 1000)) - ((satellitePriceEuro * rangeValue / 1000))).toFixed(1) + " thousands";

    const saveMoneyCompareWithDroneEuro = (((dronePriceEuro * rangeValue) / 1000) - ((satellitePriceEuro * rangeValue) / 1000)).toFixed(1);

    //SAVE WEEKS SATELLITE vs HELICOPTER and DRONE
    const saveWeeksCompareWithHelicopter = measure === "km"
        ? ((helicopterTime * rangeValue / 10080) - (satelliteTime * rangeValue / 10080)).toFixed(1)
        : ((helicopterTime * (rangeValue / 0.6214) / 10080) - ((satelliteTime * (rangeValue / 0.6214) / 10080))).toFixed(1)
    ;
    const saveWeeksCompareWithDrone = measure === "km"
        ? ((droneTime * rangeValue / 10080) - (satelliteTime * rangeValue / 10080)).toFixed(1)
        : (((droneTime * (rangeValue / 0.6214) / 10080)) - ((satelliteTime * (rangeValue / 0.6214) / 10080))).toFixed(1)
    ;

    return (
        <div className="cards">
            <div className="cards-container">

                {/*CO2 EMISSION PER KILOMETER OR MILES*/}
                <div className="cards-style plants">
                    <div className="pic">
                        <img
                            src="https://spaceptstaging.wpengine.com/wp-content/uploads/2021/02/growth.png"
                            alt="growth"
                            className="cards-style-pic"
                        />
                    </div>
                    <div className="cards-style-text">
                        <h3 className="cards-style-text-3">
                            {saveCO2EmissionHelicopter} tonnes CO<sub>2</sub>
                        </h3>
                        <span
                            className="cards-style-text-small">saved per inspection compared with helicopters</span>
                        <h3 className="cards-style-text-3">
                            {saveCO2EmissionDrone} tonnes CO<sub>2</sub>
                        </h3>
                        <span className="cards-style-text-small">compared with drones</span>
                    </div>
                </div>

                {/*COAST PER KILOMETER OR MILES*/}
                <div className="cards-style money">
                    <div className="pic">
                        <img
                            src="https://spaceptstaging.wpengine.com/wp-content/uploads/2021/02/savings.png"
                            alt="saving"
                            className="cards-style-pic"
                        />
                    </div>
                    <div className="cards-style-text">
                        <h3 className="cards-style-text-3">
                            {currency === true
                                ? `€${saveMoneyCompareWithHelicopterEuro.replace('.', ',')}`
                                : `$${saveMoneyCompareWithHelicopter.replace('.', ',')}`
                            }
                        </h3>
                        <span
                            className="cards-style-text-small">saved per inspection compared with helicopters</span>
                        <h3 className="cards-style-text-3">
                            {currency === true
                                ? `€${saveMoneyCompareWithDroneEuro.replace('.', ',')} thousands`
                                : `$${saveMoneyCompareWithDrone.replace('.', ',')} thousands`
                            }
                        </h3>
                        <span className="cards-style-text-small">compared with drones</span>
                    </div>
                </div>

                {/*WEEKS SAVES*/}
                <div className="cards-style time">
                    <div className="pic">
                        <img
                            src="https://spaceptstaging.wpengine.com/wp-content/uploads/2021/02/stop-watch.png"
                            alt="watch"
                            className="cards-style-pic"
                        />
                    </div>
                    <div className="cards-style-text">
                        <h3 className="cards-style-text-3">
                            {saveWeeksCompareWithHelicopter.replace('.', ',')} weeks
                        </h3>
                        <span
                            className="cards-style-text-small">saved per inspection compared with helicopters</span>
                        <h3 className="cards-style-text-3">
                            {saveWeeksCompareWithDrone.replace('.', ',')} weeks
                        </h3>
                        <span className="cards-style-text-small">compared with drones</span>
                    </div>
                </div>
            </div>
        </div>
    )
}
